export default class FormSuccess {
  
  constructor() {
    if (this.setVars()) {
      this.setEvents();
    }
  }
  
  setVars() {
    this.settings = {
      'success': 'data-form-success',
      'header' : 'data-header'
    };
    
    this.form_success = document.querySelector(`[${this.settings.success}]`);
    
    if (!this.form_success) return;
    
    return true;
  }
  
  setEvents() {
    window.addEventListener('wpfFormSendAfter', (e) => {
      
      if (e.detail.success) {
        document.querySelector(`[${this.settings.success}]`).addClass('active');
        document.querySelector(`[${this.settings.header}]`).addClass('d-none');
      }
    })
  }
}
